import React, { useEffect, useState } from "react";
import Icons from "../../../assets/icons";
import styled from "./AddToCart.module.css";
import Image from "../../../assets/image";
import InputSelect from "../../../components/common/input/InputSelect";
import Button from "../../../components/common/button/Button";
import RadioButton from "../../../components/common/input/RadioButton";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import callApi from "../../../services/api/apiClient";
import { dispatchStore } from "../../../lib/dispatchStore";
import { requestProductSlice } from "../../../helper/customSlice";
import ModalProvider from "../../../components/modal/ModalProvider";
import { useToast } from "../../../components/toast/Toast";

const AddToCart = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const [selectWarehouse, setSelectWarehouse] = useState(null);
  const [selectValue, setSelectValue] = useState("pickup");
  const [isDelete, setIsDelete] = useState(false);
  const [selectId, setSelectId] = useState(null);

  const selectedProduct = useSelector(
    (state) => state?.requestProductSlice?.selectedProductList
  );
  const warehouseList = useSelector(
    (state) => state?.transfer?.getWarehouseList
  )?.data;

  useEffect(() => {
    getWarehouseList();
  }, [selectedProduct]);

  const getWarehouseList = () => {
    callApi("transfer/getWarehouseList")
      .loadingGroup("warehouse")
      .executeDispatch();
  };
  console.log(selectedProduct, warehouseList, "selectedProduct in add to cart");

  const onSendRequest = () => {
    const product_arr = selectedProduct?.map((item) => item?.id);
    const data = {
      transfer_type: "request_to_main",
      delivery_type: selectValue,
      products: product_arr?.length > 0 ? product_arr : [],
      location_id: selectWarehouse,
    };

    callApi("transfer/sendRequest")
      .withBody(data)
      .loadingGroup("addtocard")
      .execute()
      .then((res) => {
        if (res?.status === "success") {
          dispatchStore(requestProductSlice.actions.resetSelectProduct());
          navigate("/request_product_list");
          showToast("Send Request is successful!", "success");
        } else {
          console.log("ERROR", res?.error);
          showToast(res?.message ? res?.message : res?.error, "error");
        }
      });
  };

  const deleteRequestProduct = () => {
    dispatchStore(requestProductSlice.actions.deleteSelectProduct(selectId));
    setIsDelete(false);
  };

  const handleChange = (event) => {
    setSelectValue(event.target.value);
  };

  console.log("Select", selectWarehouse);

  return (
    <div className="p-6">
      <div className="flex" onClick={() => navigate("/product_list")}>
        <img src={Icons.back} alt="" className="w-[24px] h-[24px]" />
        <p className={styled.title}>Cart</p>
      </div>

      <div>
        <table className="flex-1 table-auto w-full mt-[40px]">
          <thead className="text-left">
            <tr className={styled.table_header_row}>
              <th className="w-[10%]">Product</th>
              <th className="w-[12%]">Product No.</th>
              <th className="w-[10%]">Price</th>
              <th className="w-[20%]">Action</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {selectedProduct?.length > 0 ? (
              selectedProduct?.map((item, index) => (
                <tr
                  key={index}
                  className="h-[57px] border-b border-b-black-2"
                  onClick={() => onSendRequest()}
                >
                  <td className="px-3 py-2">
                    <img
                      src={Image.cartDefault}
                      alt="defaultImg"
                      className="w-[56px] h-[48px]"
                    />
                  </td>
                  <td className={`${styled.table_body_column} `}>
                    {item?.lot_no}
                  </td>
                  <td>
                    <p className="text-sm font-interRegular">{item?.price}</p>
                  </td>
                  <td className="py-2 px-3">
                    <div
                      className="cursor-pointer  items-center  justify-center"
                      onClick={() => {
                        setIsDelete(true);
                        setSelectId(item?.id);
                      }}
                    >
                      <img
                        src={Icons.bin}
                        alt=""
                        className="w-[22px] h-[20px]"
                      />
                    </div>
                  </td>
                  <td className="w-1/12"></td>
                </tr>
              ))
            ) : (
              <p className="text-center text-base self-center mt-6">
                There is no data.
              </p>
            )}
          </tbody>
        </table>
      </div>

      <div className="mt-4">
        <InputSelect
          name={"township"}
          data={warehouseList}
          label={"To Warehouse"}
          className={"w-full"}
          value={selectWarehouse}
          onChange={(event) => setSelectWarehouse(event.target.value)}
          placeholder="Select"
        />

        <p className="mt-5 text-base font-interSemiBold">Delivery Type</p>
        <div className="mt-3 flex">
          <RadioButton
            label="Pickup"
            value="pickup"
            checked={selectValue === "pickup"}
            onChange={handleChange}
          />

          <div className="ml-6">
            <RadioButton
              label="Delivery"
              value="delivery"
              checked={selectValue === "delivery"}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* <div className='flex'>
                    <div>
                        <input
                            id="pickup"
                            type="radio"
                            value={"pickup"}
                            style={{ accentColor: "red" }}
                            checked={selectValue === "pickup"}
                            onChange={handleRadioChange}
                        />
                        <label htmlFor="pickup" className="ml-2">
                            {translate("b2c", "B2C Customer")}
                        </label>
                    </div>

                </div> */}

        <Button
          type={"submit"}
          className={styled.sendBtn}
          onClick={() => onSendRequest()}
        >
          Send Request
        </Button>
      </div>

      <ModalProvider
        isOpen={isDelete}
        onClose={() => setIsDelete(false)}
        title={"Delete Request Product"}
        cancelBtn={() => setIsDelete(false)}
        sendBtn={() => deleteRequestProduct()}
        description={"Are you sure you want to  delete request product?"}
      />
    </div>
  );
};

export default AddToCart;
